import { FontWeights, ILinkStyles, IProcessedStyleSet, IStyle, ISpinnerStyles, mergeStyleSets } from "office-ui-fabric-react";
import { AppLayoutSettings } from '../common.styles';

export const getRecoveryLinkStyles = (): ILinkStyles => {
  return AppLayoutSettings.AppCommonStyles.getLinkStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.AppColors.linkColor);
};

export interface RecoveringPageStyles {
  labelContainer: IStyle;
  buttonContainer: IStyle;
  spinnerContainer: IStyle;
}

export const getRecoveringPageStyles = (): IProcessedStyleSet<RecoveringPageStyles> => {
  const styles: RecoveringPageStyles = {
    labelContainer: {
      width: '100%'
    },
    buttonContainer: {
      marginTop: '64px',
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%'
    },
    spinnerContainer: {
      marginTop: '64px',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    }
  };

  return mergeStyleSets(styles);
}

export const getSpinnerStyles = (): Partial<ISpinnerStyles> => {
  return {
    circle: {
      borderTopColor: AppLayoutSettings.AppColors.primaryWidgetColor
    },
    label: {
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx,
      fontWeight: FontWeights.regular,
      color: AppLayoutSettings.AppColors.primaryWidgetColor
    }
  };
}